import { TranslationsContext } from '@teliaee/telia-translate';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { AnalyticsTrigger, Banner, BannerHeading, BannerItem, Button, EqualHeight, Modal, Separator, Text, THeadingLevel } from 'telia-front-react';
import ProposalStore from '../../stores/ProposalStore';
import SsoStore, { CUSTOMER_TYPE_PRIVATE } from '../../stores/SsoStore';
import ProposalContent from './ProposalContent';

interface ProposalsCardProps {
  headingLevel: THeadingLevel;
  ssoStore?: SsoStore;
  proposalStore?: ProposalStore;
}

const ProposalsCard = (props: ProposalsCardProps): JSX.Element => {
  const { translate } = React.useContext(TranslationsContext);
  const { headingLevel, ssoStore, proposalStore } = props;
  const isB2C = CUSTOMER_TYPE_PRIVATE === ssoStore.customerType;

  return (
    <>
      <Banner background="brand-secondary-bg-subtle">
        <BannerItem
          id={'banner-item-mobile-recommendation'}
          image={{
            src: isB2C
              ? 'https://res.cloudinary.com/telia/image/upload/fl_lossy,f_auto,q_auto:best/tweb/pakkumine-telefonid'
              : 'https://res.cloudinary.com/telia/image/upload/fl_lossy,f_auto,q_auto:best/tweb/mobiiltelefonid-720x450',
            role: 'presentation'
          }}
        >
          <EqualHeight group="offer-content">
            <BannerHeading level={headingLevel} className="h3">
              {translate('proposal.mobileRecommendations.cardTitle')}
            </BannerHeading>
            <Text>
              <p>{translate(`proposal.mobileRecommendations${isB2C ? '.B2C' : '.B2B'}.cardText`)}</p>
            </Text>
          </EqualHeight>
          <Separator spacing="xsmall" color="invisible" />
          <EqualHeight group="offer-cta">
            <AnalyticsTrigger trigger={{ id: 'Link - Vaatan lähemalt mobiilisoovitusi', callback: 'onClick' }}>
              <Button
                text={translate('proposal.mobileRecommendations.buttonText')}
                iconRight="#arrow-right"
                block={true}
                onClick={() => proposalStore.toggleProposalModal(true)}
              />
            </AnalyticsTrigger>
          </EqualHeight>
        </BannerItem>
      </Banner>
      <Modal isOpen={proposalStore.isProposalModalOpen} onClose={() => proposalStore.toggleProposalModal(false)}>
        <ProposalContent isModal={true} />
      </Modal>
    </>
  );
};

export default inject('ssoStore', 'proposalStore')(observer(ProposalsCard));
